import { render } from "./AtendimentoRapido.vue?vue&type=template&id=32ee54c7&scoped=true&lang=pug"
import script from "./AtendimentoRapido.vue?vue&type=script&setup=true&lang=js"
export * from "./AtendimentoRapido.vue?vue&type=script&setup=true&lang=js"

import "./AtendimentoRapido.vue?vue&type=style&index=0&id=32ee54c7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ee54c7"]])

export default __exports__